export const routes = {
  notFound: '/not-found',
  landingPage: 'landing-page',
  preQualified: 'pre-qualified',
  engineLanding: 'portal',
} as const;
